import type { IconSvgObject } from './types';

const PointingLeft02Icon: IconSvgObject = [
  ["path", { d: "M22 20H20L17.6892 20.9983C16.2125 21.7055 13.3226 22.6731 11.9618 21.3209C9.81667 19.1893 9.42404 16.2081 9.5 14.4999L3.75 14.4999C2.7835 14.4999 2 13.7164 2 12.7499C2 11.7834 2.7835 10.9999 3.75 10.9999L10 10.9999M10 10.9999L14 11M10 10.9999C10.0111 10.9853 12.1731 8.12241 13.6086 7.62367C14.8916 7.17793 16.0336 8.03229 17.0914 8.67457C17.9105 9.1719 20 11 20 11H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 4.5L4.5 2M2 4.5L4.5 7M2 4.5L8 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PointingLeft02Icon;
